import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import styles from "../styles/Login.module.scss";
import ThemeSwitcher from "../../theme/components/ThemeSwitcher";

import { getBrand } from "./utils/brandHelper";
import { getBrandLogosWithFallback } from "./utils/brandConfig";
import { useTheme } from "theme/components/ThemeProvider";
import { getAuthRedirectUri, safeReturnTo } from "../config/authRedirect";

function Login() {
  const [loading, setLoading] = useState(false);
  const { loginWithRedirect } = useAuth0();

  //Get current theme and brand
  const { theme } = useTheme();                 
  const isDark = theme === 'theme-dark';
  const brand = getBrand();
  
  // State for logos with fallback
  const [logos, setLogos] = useState({
    lightLogo: "",
    logo: "",
    nube: ""
  });
  const [logoSrc, setLogoSrc] = useState("");

  // Load logos with fallback validation
  useEffect(() => {
    const loadLogos = async () => {
      try {
        const brandLogos = await getBrandLogosWithFallback(brand);
        setLogos(brandLogos);
        setLogoSrc(isDark ? brandLogos.lightLogo : brandLogos.logo);
      } catch (error) {
        console.error("Error loading brand logos:", error);
      }
    };
    
    loadLogos();
  }, [brand]);

  useEffect(() => {
    if (logos.lightLogo && logos.logo) {
      setLogoSrc(isDark ? logos.lightLogo : logos.logo);
    }
  }, [isDark, logos.lightLogo, logos.logo]);

  const handleLogin = async () => {
    setLoading(true);
    try {
      // Save intended destination before redirecting to Auth0
      const params = new URLSearchParams(window.location.search);
      const returnTo = safeReturnTo(params.get("returnTo"));
      sessionStorage.setItem("auth_return_to", returnTo);

      await loginWithRedirect({
        redirectUri: getAuthRedirectUri(),
      });
    } catch (error) {
      console.error("Error logging in with Auth0:", error);
      setLoading(false);
    }
  };

  return (
    <div className={styles["custom-container"]}>
      {/* Top-right: Theme Switcher */}
      <div style={{ position: "absolute", top: 20, right: 20, zIndex: 9999 }}>
        <ThemeSwitcher />
      </div>

      {/* Main content container */}
      <div className={styles["content-container"]}>
        {/* Left side */}
        <div className={styles["left-col"]}>
          <div className={styles["nube-container"]}>
            {/* Aquí usamos la imagen de la nube según la marca */}
            <img alt="Cloud" src={logos.nube} className={styles["nube-image"]} />
          </div>
        </div>

        {/* Right side */}
        <div className={styles["right-col"]}>
          <div className={styles["login-container"]}>
            {/* Aquí renderizamos la ruta estática del logo */}
            <img
              src={logoSrc}
              alt="Brand Logo"
              className="h-auto text-semantic-text-primary w-[350px] mb-[30px]"
            />

            <p className={styles["login-title"]}>Log in into your account</p>

            {/* Button to trigger Auth0 login */}
            <button
              type="button"
              className={styles["login-button"]}
              onClick={handleLogin}
              disabled={loading}
              style={{ marginTop: "1rem" }}
            >
              {loading ? (
                <div
                  className={`${styles["animate-spin"]} rounded-full border-4 border-current border-t-transparent w-6 h-6 mx-auto`}
                  role="status"
                  aria-label="loading"
                />
              ) : (
                "Log In"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
